import { defineProperty as _defineProperty, inherits as _inherits, createClass as _createClass, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { formatClassName as _formatClassName } from '../utils/formatClassName.js';
/** renders a banner at the bottom of the page header */

var PageBanner = /*#__PURE__*/function (_Component) {
  function PageBanner() {
    _classCallCheck(this, PageBanner);

    return _callSuper(this, PageBanner, arguments);
  }

  _inherits(PageBanner, _Component);

  return _createClass(PageBanner, [{
    key: "render",
    value: function render() {
      var className = this.props.className;

      var bannerClassName = _formatClassName(['page-banner', className]);

      return /*#__PURE__*/React.createElement("div", {
        className: bannerClassName
      }, this.props.children);
    }
  }]);
}(Component);

_defineProperty(PageBanner, "propTypes", {
  /** children are rendered inside of the page banner */
  children: PropTypes.any,

  /** adds the className to the banner wrapper */
  className: PropTypes.string
});

PageBanner.displayName = "PageBanner";
export { PageBanner };